export default "__VITE_ASSET__ef1b3cc9__"